<script>
import InputMask from '../__components/InputMask.vue';
import DatePicker from '../__components/DatePicker.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    InputMask,
    DatePicker,
  },
  props: {
    value: {
      type: Date,
    },
  },
};
</script>
<template>
  <div class="f-flex f-item-date">
    <DatePicker
      :value="value"
      :min="module.options.min"
      :max="module.options.max"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </div>
</template>
<style lang="scss">
.f-flex {
  &.f-item-date{
    .el-date-editor{
      width: 100%;
      .el-icon-date{
        display: none;
      }
    }
    .el-input__inner{
      width: 100%;
      display: block;
    }
  }
}
</style>
